@file:OptIn(InternalResourceApi::class)

package org.zq.pixelset.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/org.zq.pixelset.generated.resources/"

@delegate:ResourceContentHash(-991_089_220)
public val Res.font.README: FontResource by lazy {
      FontResource("font:README", setOf(
        ResourceItem(setOf(), "${MD}font/README.md", -1, -1),
      ))
    }

@delegate:ResourceContentHash(563_841_504)
public val Res.font.pixelset_sans_sc: FontResource by lazy {
      FontResource("font:pixelset_sans_sc", setOf(
        ResourceItem(setOf(), "${MD}font/pixelset_sans_sc.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("README", Res.font.README)
  map.put("pixelset_sans_sc", Res.font.pixelset_sans_sc)
}
